<template>
  <BTable
    v-bind="$attrs"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.name="{ header, item, value: v }">
      <router-link
        v-if="header.getRoute"
        :to="header.getRoute(item)"
        v-text="v"
      />

      <template v-else>
        {{ v }}
      </template>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/LKPublications/formdata/table-headers-user-available'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationsAvailableForUser',
  extends: BTableSimple,
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
